module.exports = __webpack_public_path__ + "static/img/13.0317320.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/13.png
// module id = 6b7H
// module chunks = 0